module.exports = __webpack_public_path__ + "static/media/ibd_hips3.e1d7ec41.png";